import {ListBanner} from './list/ListBanner';
import {ListServico} from './list/ListServico';
import {ListParceiro} from './list/ListParceiro';
import {ListProjecto} from './list/ListProjecto';
import {ListFaq} from './list/ListFaq';
import {ListNoticia} from './list/ListNoticia';
import {AddComentario} from './add/AddComentario';
import {AddOrcamento} from './add/AddOrcamento';
import {AddContacto} from './add/AddContacto';
import {SolicitarContacto} from './add/SolicitarContacto';



const Api={
ListBanner,
ListServico,
ListParceiro,
ListProjecto,
ListFaq,
ListNoticia,
AddComentario,
AddOrcamento,
AddContacto,
SolicitarContacto,

}

export default Api;